<!--  -->
<template>
  <div class="g-tab-nav clearfix">
    <template v-for="(item,i) in options">
      <div class="tab_item fl click" :class="{'active':current== i}" @click="schange(i)">{{ item }}</div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'GTabNav',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      default: 0
    },
    options: {
      default() {
        return ['tab1', 'tab2']
      }
    }
  },
  data() {
    return {
      current: 0
    }
  },
  watch: {
    value(val) {
      this.current = val
    }
  },
  mounted() {
    this.current = this.value
  },
  methods: {
    schange(val) {
      this.current = val
      this.$emit('change', val)
    }
  }
}
</script>

<style lang='scss' scoped>
.g-tab-nav {
  display: inline-block;
  .tab_item {
    user-select: none;
    padding: 6px 20px;
    background: rgba(255, 255, 255, 0.1);
    text-align: center;
    &.active {
      background: #07d15d;
      color: #fff;
    }
  }
  .tab_item:first-of-type {
    border-radius: 20px 0 0 20px;
  }
  .tab_item:last-of-type {
    border-radius: 0 20px 20px 0;
  }
}

// 浅色主题
// .theme-light {
  .g-tab-nav {
    .tab_item {
      background: rgba(0, 0, 0, 0.05);
      &.active {
        background: #07d15d;
        color: #fff;
      }
    }
  }
// }
</style>
